// extracted by mini-css-extract-plugin
export var label = "_eo-2";
export var slideContainer = "_eo-0";
export var slider = "_eo-1";